/**
 * Deep link into student app university profile (wishlist course context).
 * Student route: /university-profile/:univId/wishlist_:courseId
 */
export function getStudentAppOrigin() {
	const fromEnv = String(
		process.env.REACT_APP_STUDENT_APP_URL ||
			process.env.REACT_APP_API_URL ||
			'https://kandor.org',
	).trim()
	return fromEnv.replace(/\/api\/?$/, '').replace(/\/$/, '') || 'https://kandor.org'
}

export function buildStudentUniversityProfileUrl(universityId, courseId) {
	const univId = String(universityId || '').trim()
	const course = String(courseId || '').trim()
	if (!univId || !course) return ''
	return `${getStudentAppOrigin()}/university-profile/${encodeURIComponent(univId)}/wishlist_${encodeURIComponent(course)}`
}

export function getResearchUniversitySelectionId(item) {
	const courses = item?.courses || {}
	const universityId = String(
		courses?.university_id || item?.id || item?.university_id || '',
	).trim()
	const courseId = String(
		item?.course_id || courses?.course_id || courses?.id || '',
	).trim()
	if (!universityId && !courseId) return ''
	return `${universityId}::${courseId}`
}
